import { render, staticRenderFns } from "./SmallButton.vue?vue&type=template&id=79f7d6e9&scoped=true&"
import script from "./SmallButton.vue?vue&type=script&lang=js&"
export * from "./SmallButton.vue?vue&type=script&lang=js&"
import style0 from "./SmallButton.vue?vue&type=style&index=0&id=79f7d6e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f7d6e9",
  null
  
)

export default component.exports